module.exports = __webpack_public_path__ + "img/icon-await.179abaa8.png";